export function safeAsign(valor){
    if(valor != null && valor != "" && valor != undefined){
      return true
    }
    return false;
}